<template>
  <InformationTemplate ref="form" :form="form" :rules="rules">
    <template #radio>
      <UploadTypeRadio
        prop="idType"
        :label="$t(radioLabel)"
        :value="form.idType"
        :options="idTypeOptions"
        :onChange="option => (form.idType = option)"
        :disabled="disabled"
      />
    </template>
    <template #form>
      <FormRowContainer>
        <InputForm
          v-model="form.firstName"
          name="firstName"
          :label="$t('register.personalDetails.page1.firstName')"
          :placeholder="$t('register.personalDetails.page1.firstName')"
          :disabled="true"
          maxlength="128"
        />
        <InputForm
          v-model="form.middleName"
          name="middleName"
          :label="$t('register.personalDetails.page1.middleName')"
          :placeholder="$t('register.personalDetails.page1.middleName')"
          :disabled="true"
          maxlength="128"
        ></InputForm>
      </FormRowContainer>
      <FormRowContainer>
        <InputForm
          v-model="form.lastName"
          name="lastName"
          :label="$t('register.personalDetails.page1.lastName')"
          :placeholder="$t('register.personalDetails.page1.lastName')"
          :disabled="true"
          maxlength="128" />
        <InputForm
          v-model="form.idNumber"
          name="idNumber"
          :label="$t('verificationStatus.idInformation.idNumber')"
          :placeholder="$t('verificationStatus.idInformation.idNumber')"
          :disabled="disabled"
          class="showPlaceholder"
          maxlength="128"
      /></FormRowContainer>
      <FormRowContainer>
        <SelectForm
          v-model="form.nationalityId"
          :label="$t('register.personalDetails.page1.nationality')"
          :placeholder="$t('register.personalDetails.page1.nationality')"
          :disabled="disabled"
          class="showPlaceholder"
          name="nationalityId"
        >
          <el-option
            v-for="(item, index) in nationalities"
            :key="index"
            :label="item.nationality"
            :value="item.id"
            :data-testid="item.id < 10 ? 'nationality0' + item.id : 'nationality' + item.id"
          ></el-option>
        </SelectForm>
        <div
      /></FormRowContainer>
      <el-divider v-if="isShowAddressInputs" class="mt-0 mb-[45px] bg-grayG3" />
      <div v-if="isShowAddressInputs" class="flex flex-col items-stretch justify-start gap-2">
        <FormRowContainer>
          <SelectForm
            class="showPlaceholder"
            v-model="form.countryId"
            :disabled="true"
            :label="$t('register.personalDetails.page2.mainResidency')"
            name="countryId"
          >
            <el-option
              v-for="(item, index) in countries"
              :key="index"
              :label="item.countryName"
              :value="item.id"
            ></el-option>
          </SelectForm>
          <div />
        </FormRowContainer>
        <FormRowContainer>
          <div v-if="showDiffField" class="flex flex-wrap items-stretch justify-start gap-7.5">
            <InputForm
              class="flex-1 showPlaceholder"
              :label="$t('register.personalDetails.page2.streetNumber')"
              :placeholder="$t('register.personalDetails.page2.streetNumber')"
              :disabled="disabled"
              name="streetNumber"
              maxlength="20"
              v-model="form.streetNumber"
            />
            <InputForm
              class="flex-1 showPlaceholder"
              :label="$t('register.personalDetails.page2.streetName')"
              :placeholder="$t('register.personalDetails.page2.streetName')"
              :disabled="disabled"
              name="address"
              maxlength="256"
              v-model="form.address"
            />
          </div>
          <InputForm
            v-else
            class="showPlaceholder"
            :label="$t('register.personalDetails.page2.address')"
            :placeholder="$t('register.personalDetails.page2.address')"
            :disabled="disabled"
            name="address"
            maxlength="256"
            v-model="form.address"
          />
          <InputForm
            :label="$t('register.personalDetails.page2.provinceOrState')"
            :placeholder="$t('register.personalDetails.page2.provinceOrState')"
            :disabled="disabled"
            class="showPlaceholder"
            name="state"
            maxlength="128"
            v-model="form.state"
          ></InputForm>
        </FormRowContainer>
        <FormRowContainer>
          <InputForm
            :label="$t('register.personalDetails.page2.cityOrSuburb')"
            :placeholder="$t('register.personalDetails.page2.cityOrSuburb')"
            :disabled="disabled"
            class="showPlaceholder"
            name="suburb"
            maxlength="128"
            v-model="form.suburb"
          />
          <InputForm
            :label="$t('register.personalDetails.page2.postcode')"
            :placeholder="$t('register.personalDetails.page2.postcode')"
            :disabled="disabled"
            class="showPlaceholder"
            name="postcode"
            maxlength="64"
            v-model="form.postcode"
          />
        </FormRowContainer>
      </div>
    </template>
  </InformationTemplate>
</template>

<script>
import { mapState } from 'vuex';
import { countryCodeEnum } from '@/constants/country';
import FormRowContainer from '../formRows/FormRowContainer.vue';
import InformationTemplate from './templates/InformationTemplate.vue';
import UploadTypeRadio from './components/UploadTypeRadio.vue';
import poiStore from '@/store/register/poiVerification/poiStore';

const SPECIAL_CARD_ID_NATIONALITYS = [103] // Hong Konger---103
const SPECIAL_CARD_ID_COUNTRYs = [countryCodeEnum.MACAO, countryCodeEnum.HONG_KONG]

export const idType = Object.freeze({
  id: 1,
  passport: 2,
  other: 4
});

export default {
  name: 'IdInformation',
  components: {
    FormRowContainer,
    InformationTemplate,
    UploadTypeRadio
  },
  props: {
    radioLabel: { type: String, required: true },
    idTypeOptions: { type: Array, required: true },
    disabled: { type: Boolean, default: false },
    isShowAddressInputs: { type: Boolean, default: false }
  },
  data() {
    let _this = this;
    let validatorIdNumber = function (rule, value, callback) {
      // ACM-31459 HK \Macao 客户的ID证件格式为A123456(1) 取消限制()的输入
      if (
        _this.form.idType == 1 &&
        (SPECIAL_CARD_ID_NATIONALITYS.includes(Number(_this.form.nationalityId)) ||
          SPECIAL_CARD_ID_COUNTRYs.includes(Number(poiStore.state.countryId)) || 
          SPECIAL_CARD_ID_COUNTRYs.includes(Number(_this.form.countryId)))
      ) {
        if (!/^[a-zA-Z0-9]+(\([a-zA-Z-0-9]+\))?$/.test(value)) {
          return callback(new Error(_this.$t('common.formValidation.idSpecialNew')))
        } else {
          return callback()
        }
      }
      let isIdNumber = /^[a-zA-Z0-9]+$/.test(value)
      if (!isIdNumber) {
        return callback(new Error(_this.$t('common.formValidation.idSpecial')))
      }
      return callback()
    };
    return {
      form: {
        firstName: '',
        middleName: null,
        lastName: '',
        nationalityId: null,
        idType: null,
        idNumber: ''
      },
      rules: {
        firstName: [
          {
            required: true,
            trigger: 'blur',
            message: this.$t('common.formValidation.firstNameReq')
          },
          {
            max: 50,
            message: this.$t('common.formValidation.noteMoreThan', {
              limit: 50
            })
          },
          {
            min: 1,
            message: this.$t('common.formValidation.noteLessThan', {
              limit: 1
            })
          }
        ],
        middleName: [
          {
            required: false,
            trigger: 'blur'
          },
          {
            max: 50,
            message: this.$t('common.formValidation.noteMoreThan', {
              limit: 50
            })
          }
        ],
        lastName: [
          {
            required: true,
            trigger: 'blur',
            message: this.$t('common.formValidation.lastNameReq')
          },
          {
            min: 1,
            message: this.$t('common.formValidation.noteLessThan', {
              limit: 1
            })
          },
          {
            max: 50,
            message: this.$t('common.formValidation.noteMoreThan', {
              limit: 50
            })
          }
        ],
        nationalityId: [
          {
            required: true,
            trigger: 'change',
            message: this.$t('common.formValidation.nationalityReq')
          }
        ],
        idType: [
          {
            required: true,
            trigger: 'change',
            message: this.$t('common.formValidation.idTypeReq')
          }
        ],
        idNumber: [
          {
            required: true,
            trigger: 'blur',
            message: this.$t('common.formValidation.idNumReq')
          },
          {
            validator: validatorIdNumber,
            required: true,
            trigger: 'blur'
          },
          {
            max: 45,
            message: this.$t('common.formValidation.noteMoreThan', {
              limit: 45
            })
          }
        ]
      }
    };
  },
  computed: {
    showDiffField() {
      return this.form.countryId !== null ? this.diffFieldCountryList.includes(parseInt(this.form.countryId)) : false;
    },
    lang() {
      return this.$store.state.common.lang;
    },
    ...mapState('register', ['nationalities', 'countries'])
  },
  watch: {
    lang() {
      this.$store.dispatch('register/getNationalities', this.lang);
      if (this.isShowAddressInputs) {
        this.$store.dispatch('register/getCountries', this.lang);
      }
    },
    isShowAddressInputs(isShowAddressInputs) {
      if (isShowAddressInputs) {
        this.$store.dispatch('register/getCountries', this.lang);
        // Add address inputs
        // addressForm first to prevent removing initial value from parent component
        this.form = {
          ...this.addressForm,
          ...this.form
        };

        this.rules = { ...this.addressRules, ...this.rules };

        // nextTick to run clearValidate after rules changed
        this.$nextTick(() => this.clearValidate());
      } else {
        // Remove address inputs
        this.removeAddressForm();
        this.removeAddressRules();
        // nextTick to run clearValidate after rules changed
        this.$nextTick(() => this.clearValidate());
      }
    }
  },
  created() {
    this.diffFieldCountryList = [countryCodeEnum.UNITED_KINGDOM, countryCodeEnum.FRANCE, countryCodeEnum.MALAYSIA];
    this.addressForm = {
      countryId: null,
      streetNumber: '',
      address: '',
      state: '',
      suburb: '',
      postcode: ''
    };
    this.addressRules = {
      countryId: [
        {
          required: false,
          trigger: 'change',
          message: this.$t('common.formValidation.countryReq')
        }
      ],
      streetNumber: [
        {
          required: true,
          trigger: 'blur',
          message: this.$t('common.formValidation.numberReq')
        }
      ],
      address: [
        {
          required: true,
          trigger: 'blur',
          message: this.$t('common.formValidation.addressReq')
        }
      ],
      state: [
        {
          required: true,
          trigger: 'blur',
          message: this.$t('common.formValidation.stateReq')
        }
      ],
      suburb: [
        {
          required: true,
          trigger: 'blur',
          message: this.$t('common.formValidation.suburbReq')
        }
      ],
      postcode: [
        {
          required: true,
          trigger: 'blur',
          message: this.$t('common.formValidation.postcodeReq')
        }
      ]
    };
    this.form.idType = this.idTypeOptions[0].value;
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.$store.dispatch('register/getNationalities', this.lang);
      if (this.isShowAddressInputs) {
        this.$store.dispatch('register/getCountries', this.lang);
      }
    },
    removeAddressForm() {
      const { firstName, middleName, lastName, nationalityId, idType, idNumber } = this.form;

      this.form = { firstName, middleName, lastName, nationalityId, idType, idNumber };
    },
    removeAddressRules() {
      const { firstName, middleName, lastName, nationalityId, idType, idNumber } = this.rules;
      this.rules = { firstName, middleName, lastName, nationalityId, idType, idNumber };
    },
    validateField(props, callback) {
      this.$refs.form?.validateField(props, callback);
    },
    validate(callback) {
      this.$refs.form?.validate((valid, rules) => callback?.(valid, rules));
    },
    clearValidate(props) {
      this.$refs.form?.clearValidate(props);
    }
  }
};
</script>
